import { useState } from 'react';
import type { FormEvent } from 'react';
import { Link } from 'react-router-dom';

import { Button } from '../ui/Button';
import { Field } from '../ui/Field';
import { supabase } from './supabase-client';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function signIn(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!supabase) return;
    setPending(true);
    setError(null);
    const { error: signInError } = await supabase.auth.signInWithPassword({ email, password });
    if (signInError) {
      setError('Adresse ou mot de passe incorrect.');
    }
    setPending(false);
  }

  return (
    <main className="auth-page">
      <section className="auth-story" aria-label="Présentation ALBA">
        <div>
          <p className="eyebrow">ALBA</p>
          <h2>Une tâche, un tap, une décision.</h2>
          <p>Le tableau d'équipe d'Absolute Habitat, pour ne plus perdre une demande.</p>
        </div>
        <p className="auth-story__footer">Direction, pôles et agences, au même endroit.</p>
      </section>
      <section className="auth-card" aria-labelledby="auth-title">
        <p className="eyebrow">ALBA</p>
        <h1 id="auth-title">Connexion</h1>
        <form onSubmit={(event) => void signIn(event)} className="auth-form">
          <Field
            label="Adresse email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
          <Field
            label="Mot de passe"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
          <Button type="submit" disabled={pending}>
            {pending ? 'Connexion en cours' : 'Se connecter'}
          </Button>
        </form>
        <Link className="text-button" to="/mot-de-passe-oublie">
          Mot de passe oublié
        </Link>
        {error && (
          <p className="error-state" role="alert">
            {error}
          </p>
        )}
      </section>
    </main>
  );
}
